/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScatterDataRepresentation
 */
export interface ScatterDataRepresentation {
    /**
     * x value of the request resource, corresponding x and y points are matched via index
     * @type {Array<number>}
     * @memberof ScatterDataRepresentation
     */
    x: Array<number>;
    /**
     * y value of the request resource, corresponding x and y points are matched via index
     * @type {Array<number>}
     * @memberof ScatterDataRepresentation
     */
    y: Array<number>;
    /**
     * timestamp of the request resource used to allow table representation, corresponding x and y points are matched via index
     * @type {Array<number>}
     * @memberof ScatterDataRepresentation
     */
    timeStamps: Array<number>;
}

/**
 * Check if a given object implements the ScatterDataRepresentation interface.
 */
export function instanceOfScatterDataRepresentation(value: object): value is ScatterDataRepresentation {
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    if (!('timeStamps' in value) || value['timeStamps'] === undefined) return false;
    return true;
}

export function ScatterDataRepresentationFromJSON(json: any): ScatterDataRepresentation {
    return ScatterDataRepresentationFromJSONTyped(json, false);
}

export function ScatterDataRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScatterDataRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'x': json['x'],
        'y': json['y'],
        'timeStamps': json['timeStamps'],
    };
}

export function ScatterDataRepresentationToJSON(json: any): ScatterDataRepresentation {
    return ScatterDataRepresentationToJSONTyped(json, false);
}

export function ScatterDataRepresentationToJSONTyped(value?: ScatterDataRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'x': value['x'],
        'y': value['y'],
        'timeStamps': value['timeStamps'],
    };
}

